module.exports = __webpack_public_path__ + "img/active-challenge.3388cf53.svg";